// Contact / support channel helpers shared across admin & user views.

export const CONTACT_TYPES = [
  { id: 'whatsapp', label: 'واتساب' },
  { id: 'telegram', label: 'تليجرام' },
  { id: 'phone', label: 'اتصال هاتفي' },
  { id: 'email', label: 'بريد إلكتروني' },
  { id: 'facebook', label: 'فيسبوك' },
  { id: 'website', label: 'موقع / رابط' },
  { id: 'other', label: 'أخرى' },
];

export const contactTypeLabel = (t) =>
  (CONTACT_TYPES.find((x) => x.id === t)?.label || 'أخرى');

// Build a clickable href for a given contact channel.
export const contactHref = (type, value) => {
  const v = (value || '').trim();
  const digits = v.replace(/[^0-9]/g, '');
  switch (type) {
    case 'whatsapp':
      return `https://wa.me/${digits}`;
    case 'telegram':
      return /^https?:\/\//i.test(v) ? v : `https://t.me/${v.replace(/^@/, '')}`;
    case 'phone':
      return `tel:${v}`;
    case 'email':
      return `mailto:${v}`;
    case 'facebook':
    case 'website':
    case 'other':
    default:
      return /^https?:\/\//i.test(v) ? v : `https://${v}`;
  }
};

// A short human-readable placeholder per type (for admin form hints).
export const contactPlaceholder = (t) => ({
  whatsapp: 'رقم بصيغة دولية مثال: 201012345678',
  telegram: '@username أو رابط t.me',
  phone: '01xxxxxxxxx',
  email: 'support@example.com',
  facebook: 'رابط صفحة الفيسبوك',
  website: 'https://example.com',
  other: 'الرابط أو القيمة',
}[t] || '');
